import { render, staticRenderFns } from "./material-preview.vue?vue&type=template&id=7cdad574&scoped=true"
import script from "./material-preview.vue?vue&type=script&lang=js"
export * from "./material-preview.vue?vue&type=script&lang=js"
import style0 from "./material-preview.vue?vue&type=style&index=0&id=7cdad574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdad574",
  null
  
)

export default component.exports